import { render, staticRenderFns } from "./RegistrationComponent.vue?vue&type=template&id=ec7e2bec&scoped=true&"
import script from "./RegistrationComponent.vue?vue&type=script&lang=js&"
export * from "./RegistrationComponent.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationComponent.vue?vue&type=style&index=0&id=ec7e2bec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7e2bec",
  null
  
)

export default component.exports